import classNames from "classnames";

function BaseGridItem({ children, gridConfig, ...config }) {
  return <div className={classNames('rounded-lg border border-gray-300 bg-white px-7 py-6 shadow-sm', gridConfig)}>{children}</div>;
}

function BaseGrid({ children }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-5 gap-1 md:gap-3">
      {children}
    </div>
  );
}

export { BaseGrid, BaseGridItem };
